import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  requestConfig,
  throwFromFailedResponse,
} from "../../globals";

export const saveWishlistToUserProps = z
  .object({
    token: z.string(),
    wishlistToken: z.string(),
    wishlistId: z.string(),
  })
  .extend(requestConfig.shape);

export type SaveWishlistToUserProps = z.infer<typeof saveWishlistToUserProps>;

export const saveWishlistToUser = async (
  args: SaveWishlistToUserProps,
): Promise<void> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    wishlistToken,
    wishlistId,
    proxyAuthSecret,
  } = parseServiceInput(saveWishlistToUserProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });
  if (wishlistToken) {
    headers.append("x-wishlist-token", `Bearer ${wishlistToken}`);
  }

  const response = await fetch(`${endpoint}/v3/wishlist/${wishlistId}`, {
    method: "POST",
    headers,
  });

  if (!response.ok) {
    await throwFromFailedResponse(response);
  }

  return;
};
